import styled from 'styled-components';
import { resetButtonStyle } from '../../styles/mixins';
import { link } from '../../styles/typography';
const Link = /*#__PURE__*/styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-17fm8jm-0"
})(["", " ", " font:inherit;"], resetButtonStyle, link);
export { Link };